"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguageFromLanguageCode = void 0;
const getLanguageFromLanguageCode = languageCode => languageCode.split('-')[0].toLowerCase();
exports.getLanguageFromLanguageCode = getLanguageFromLanguageCode;
